import { TextField, Typography } from '@mui/material';
import { WorkflowParameter } from 'api/model';

export type Props = {
  parameters: WorkflowParameter[];
  values: Record<string, string>;
  onChange: (values: Record<string, string>) => void;
  readOnly?: boolean;
};

const WorkflowParameterValuesForm = ({ parameters, values, onChange, readOnly = false }: Props) => {
  if (parameters.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 my-2">
      <Typography variant="subtitle1">Parameters</Typography>
      {parameters.map((parameter) => {
        const required = parameter.default_value === null;
        const value = values[parameter.name] ?? '';
        const showError = required && value.length === 0;
        return (
          <TextField
            key={parameter.name}
            label={parameter.name}
            value={value}
            onChange={(e) => onChange({ ...values, [parameter.name]: e.target.value })}
            required={required}
            error={showError}
            helperText={showError ? 'This parameter is required' : parameter.description || undefined}
            disabled={readOnly}
            fullWidth
          />
        );
      })}
    </div>
  );
};

export default WorkflowParameterValuesForm;
